const en = {
  brand: {
    name: "Gujarat Pharma Union",
    short: "GPU",
    motto: "Unity • Compliance • Protection",
    positioning: "For Genuine Medicines • Fair Trade • Stronger Pharmaceutical Community",
  },
  nav: {
    home: "Home",
    about: "About",
    aboutGpu: "About GPU",
    objectives: "Our Objectives",
    committees: "Leadership & Committees",
    districts: "District Chapters",
    institutional: "Institutional Engagement",
    ethics: "Code of Ethics",
    membership: "Membership",
    memberBenefits: "Member Benefits",
    memberRegistration: "How to Become a Member",
    declaration: "Membership Declaration",
    vendors: "Vendors",
    vendorNetwork: "Vendor Network",
    vendorRegistration: "Vendor Registration",
    protection: "Protection",
    gpuProtection: "GPU Protection",
    safeTrade: "Safe Trade Network",
    antiCounterfeit: "Anti-Counterfeit",
    resources: "Resources",
    knowledge: "Knowledge Center",
    downloads: "Download Center",
    faq: "FAQ",
    news: "News & Updates",
    events: "Events",
    media: "Media",
    verify: "Verify GPU ID",
    contact: "Contact",
    menu: "Menu",
    close: "Close",
  },
  cta: {
    joinMember: "Join as Member",
    registerVendor: "Register as Vendor",
    memberLogin: "Member Login",
    vendorLogin: "Vendor Login",
    joinGpu: "Join GPU",
    knowMore: "Know More",
    startMemberRegistration: "Start Member Registration",
    startApplication: "Start Application",
    applyAsVendor: "Apply as Vendor",
    exploreProtection: "Explore GPU Protection",
    learnSafeTrade: "Learn about Safe Trade",
    viewAllCommittees: "View All Committees",
    verifyMember: "Verify GPU Member",
    verifyVendor: "Verify GPU Vendor",
    becomeMember: "Become a Member",
    memberLoginForSupport: "Member Login for Support",
    openApp: "Open GPU App",
    getApp: "Get the GPU App",
    viewAll: "View all",
    readMore: "Read more",
    back: "Back to Home",
  },
  common: {
    comingSoon: "Coming Soon",
    important: "Important",
    disclaimer: "Disclaimer",
    language: "Language",
    english: "English",
    gujarati: "ગુજરાતી",
    noContentYet:
      "This section is managed by the GPU secretariat. Content will appear here once officially published.",
    searchPlaceholder: "Search resources, circulars, FAQs…",
    loading: "Loading…",
    appNote:
      "Registration and login are handled inside the official GPU mobile application and member portal.",
  },
  footer: {
    tagline:
      "A professional collective of licensed pharmaceutical traders in Gujarat working for compliance, genuine medicines and responsible trade.",
    organisation: "Organisation",
    membershipCol: "Membership",
    protectionCol: "Protection",
    resourcesCol: "Resources",
    legal: "Legal",
    privacy: "Privacy Policy",
    terms: "Terms of Use",
    disclaimerPage: "Disclaimer",
    circulars: "GPU Circulars",
    rights: "© {year} Gujarat Pharma Union. All rights reserved.",
    independence:
      "GPU is an independent trade body. It is not a Government department and claims no Government affiliation or endorsement.",
  },
};

export default en;
